// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PhotoCompressController from "./photo_compress_controller"
application.register("photo-compress", PhotoCompressController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import WineFilterController from "./wine_filter_controller"
application.register("wine-filter", WineFilterController)
